import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import Zoom from 'react-reveal/Zoom';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "the-nutcracker",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#the-nutcracker",
        "aria-label": "the nutcracker permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`The Nutcracker`}</h1>
    <h2 {...{
      "id": "ballet-west",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#ballet-west",
        "aria-label": "ballet west permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Ballet West`}</h2>
    <blockquote>
      <p parentName="blockquote">{`🔇 We appreciate you silencing your phone.`}</p>
    </blockquote>
    <small>
      <p>{`All information was published as of November 22, 2022`}</p>
    </small>
    <Link to="/nutcracker" mdxType="Link">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBAX/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAegts005UVoaZ6WKif/EABoQAQEBAQADAAAAAAAAAAAAAAECABESISP/2gAIAQEAAQUC8XvRea1kihc4gL1Fb6aT1//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/AVVX/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8BIf/EAB0QAAIBBAMAAAAAAAAAAAAAAAABERAhIjEygZH/2gAIAQEABj8CmehpO6Lkolbe6yqYpM4L0yVz/8QAHBABAQEAAwADAAAAAAAAAAAAAQARITFhQVGR/9oACAEBAAE/ITTqj+L1kIQctbAGh2fM8D7EknExjBpcxXhPWyp3qeG//9oADAMBAAIAAwAAABDE63P/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEQ/9oACAEDAQE/EB3gZav/xAAXEQEAAwAAAAAAAAAAAAAAAAAAEBEh/9oACAECAQE/EIox/8QAHxABAAICAgIDAAAAAAAAAAAAAQARITFBUWFxgdHw/9oACAEBAAE/ECu1pBWHDDV/1DUrgdgVAhc6paeIJ9TZx4N/Eyy5GErsZTkRGhz+7lLNV7h+6oZRO4koJ03+4ISucKlcT//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/nutcracker-2022/static/0f1e40ee58df939b08c589a31ce3b357/8ac56/nutcracker-cover-2022.webp 240w", "/nutcracker-2022/static/0f1e40ee58df939b08c589a31ce3b357/d3be9/nutcracker-cover-2022.webp 480w", "/nutcracker-2022/static/0f1e40ee58df939b08c589a31ce3b357/87ca7/nutcracker-cover-2022.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/nutcracker-2022/static/0f1e40ee58df939b08c589a31ce3b357/09b79/nutcracker-cover-2022.jpg 240w", "/nutcracker-2022/static/0f1e40ee58df939b08c589a31ce3b357/7cc5e/nutcracker-cover-2022.jpg 480w", "/nutcracker-2022/static/0f1e40ee58df939b08c589a31ce3b357/1a144/nutcracker-cover-2022.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/nutcracker-2022/static/0f1e40ee58df939b08c589a31ce3b357/1a144/nutcracker-cover-2022.jpg",
              "alt": "rodeo cover",
              "title": "rodeo cover",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </Link>
    <blockquote>
      <p parentName="blockquote">{`📱 Please use the menu to explore our mobile friendly program.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`📖 If you prefer a traditional “page turning” format as with print publications, `}<a parentName="p" {...{
          "href": "/nutcracker-2022/digital-program"
        }}>{`please click here`}</a>{`.`}</p>
    </blockquote>
    <h3 {...{
      "id": "quick-navigation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#quick-navigation",
        "aria-label": "quick navigation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Quick Navigation`}</h3>
    <section className="home-list">
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/nutcracker">
    The Nutcracker
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/sponsors">
    Sponsors
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/ballet-west-company">
    Ballet West
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/board-of-directors">
    Board of Directors
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/from-the-artistic-director">
    From the Artistic Director
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/from-the-executive-director">
    From the Executive Director
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/wellness-partners">
    Wellness Partners
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/orchestra">
    Ballet West Orchestra
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/profiles">
    Profiles
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/digital-program">
    Digital Program
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/corporate-foundation-and-government-support">
    Corporate, Foundation, and Government Support
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/individual-donors">
    Individual Donors
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/ballet-west-guild">
    Ballet West Guild
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/house-rules">
    House Rules
  </a>
      </Zoom>
      <Zoom mdxType="Zoom">
  <a className="home-column" href="/nutcracker-2022/ballet-west-staff">
    Ballet West Staff
  </a>
      </Zoom>
    </section>
    <br />
    <br />
    <OutboundLink href="https://www.octannerjewelers.com/?utm_source=digital+playbill&utm_medium=ballet_west&utm_campaign=Cover" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAwABAgX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB9IzWV5I7J8s2o//EABwQAQACAQUAAAAAAAAAAAAAAAIBAwAUICEiMf/aAAgBAQABBQIKVVVZLmtJlhaSiO/M4vCIjb//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAfEAABBAICAwAAAAAAAAAAAAABAAIRIRJhAzEgUVL/2gAIAQEABj8CD3mJGR0ntiS2xsLqNFYGiBCfy/fUelVKvL//xAAbEAEBAQEBAQEBAAAAAAAAAAABEQAhMUEQYf/aAAgBAQABPyH3AgsBrlRIsU81p1FH1NcvXIUQw/TwfwG7Ksr0jrYUvecMAEM4H7Pz/9oADAMBAAIAAwAAABATCAz/xAAVEQEBAAAAAAAAAAAAAAAAAAAgcf/aAAgBAwEBPxCD/8QAFREBAQAAAAAAAAAAAAAAAAAAIHH/2gAIAQIBAT8Qo//EAB8QAQACAgICAwAAAAAAAAAAAAEAESExQYFRYRBxof/aAAgBAQABPxDRDoSeQOuWLS0BkLSaGvrqLWsyhB8m/Pcc+YdJLErijJvcEjiuQUB7/JhABpKvPuBwDZSVhNjvA1AQAGggsxV+5xK6+P/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/nutcracker-2022/static/52e692df20d2060e6d40d5cc05f1c672/8ac56/octanner.webp 240w", "/nutcracker-2022/static/52e692df20d2060e6d40d5cc05f1c672/d3be9/octanner.webp 480w", "/nutcracker-2022/static/52e692df20d2060e6d40d5cc05f1c672/87ca7/octanner.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/nutcracker-2022/static/52e692df20d2060e6d40d5cc05f1c672/09b79/octanner.jpg 240w", "/nutcracker-2022/static/52e692df20d2060e6d40d5cc05f1c672/7cc5e/octanner.jpg 480w", "/nutcracker-2022/static/52e692df20d2060e6d40d5cc05f1c672/1a144/octanner.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/nutcracker-2022/static/52e692df20d2060e6d40d5cc05f1c672/1a144/octanner.jpg",
              "alt": "OC Tanner Jewelers",
              "title": "OC Tanner Jewelers",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>
    <OutboundLink href="https://www.larryhmillerlincolndraper.com/?utm_source=digital+playbill&utm_medium=ballet_west&utm_campaign=Cover" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAwABBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAACAf/aAAwDAQACEAMQAAABF/PQ3quKlM01F7Ir/8QAGRAAAgMBAAAAAAAAAAAAAAAAAAECERIh/9oACAEBAAEFAoVJZKIaG6LkT1qK7F0tGhKz/8QAFhEBAQEAAAAAAAAAAAAAAAAAEQAQ/9oACAEDAQE/AWd//8QAFhEBAQEAAAAAAAAAAAAAAAAAEQAQ/9oACAECAQE/ASN//8QAGxAAAgMBAQEAAAAAAAAAAAAAAAERITEQUYH/2gAIAQEABj8C74a4KUlufhhhrKb5/8QAHRAAAwACAgMAAAAAAAAAAAAAAAERITFRYUGBsf/aAAgBAQABPyFlHSPDRYlq1eWxkXvUq8ycoWtuy2GbMY/6Je/WJLICKn//2gAMAwEAAgADAAAAEPTcwv/EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAwEBPxCGEbH/xAAXEQADAQAAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EGNDn//EAB4QAQACAQQDAAAAAAAAAAAAAAEAESFBUWGRMbHB/9oACAEBAAE/EFpW9EqW3fdlqIKYa5lHFfKg6jPLak6uLjokFHqWdGhzxbZ0icvK9q7VyPUQHyIJKbnEbK8z/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/nutcracker-2022/static/81c4a60b9eedf70adf7ed17f4278239b/8ac56/lhmiller-lincoln.webp 240w", "/nutcracker-2022/static/81c4a60b9eedf70adf7ed17f4278239b/d3be9/lhmiller-lincoln.webp 480w", "/nutcracker-2022/static/81c4a60b9eedf70adf7ed17f4278239b/87ca7/lhmiller-lincoln.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/nutcracker-2022/static/81c4a60b9eedf70adf7ed17f4278239b/09b79/lhmiller-lincoln.jpg 240w", "/nutcracker-2022/static/81c4a60b9eedf70adf7ed17f4278239b/7cc5e/lhmiller-lincoln.jpg 480w", "/nutcracker-2022/static/81c4a60b9eedf70adf7ed17f4278239b/1a144/lhmiller-lincoln.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/nutcracker-2022/static/81c4a60b9eedf70adf7ed17f4278239b/1a144/lhmiller-lincoln.jpg",
              "alt": "Larry H Miller Lincoln Draper",
              "title": "Larry H Miller Lincoln Draper",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </OutboundLink>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      